import { Uf } from 'app/anuncio/models/uf.model';
import { MaterialTipo } from 'app/anuncio/models/material-tipo.model';
import { MaterialCategoria } from 'app/anuncio/models/material-categoria.model';
import { Entidade } from './entidade.model';
import { AnuncioChip } from './anuncio-chip.model';
import { AnuncioSituacao } from './anuncio-situacao.model';
import { AnuncioInteresseSituacao } from './anuncio-interesse-situacao.model';

export class FiltroMeusInteresses {
  pesquisa: string;
  materialTipos: MaterialTipo[];
  materialTiposSelecionados: MaterialTipo[];
  materialCategorias: MaterialCategoria[];
  materialCategoriasSelecionadas: MaterialCategoria[];
  anuncioInteresseSituacoes: AnuncioInteresseSituacao[];
  anuncioInteresseSituacoesSelecionadas: AnuncioInteresseSituacao[];
  ufs: Uf[];
  ufsSelecionadas: Uf[];
  periodoInclusao: Date[];
  periodoAprovacao: Date[];
  anuncios: AnuncioChip[];
  entidades: Entidade[];
  entidadesSelecionadas: Entidade[];
  interessesCancelados: boolean;

}
